module.exports = __webpack_public_path__ + "models/house_d00d4cc95417f108111355ff19b07707.glb";